import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import Login from '@/pages/Login'
import Home from '@/pages/Home'
const notFound = () => import ('@/pages/404')
const Reload = () => import ('@/pages/Reload')

const Main = () => import('@/pages/Main')
const Khlb = () => import ('@/pages/khgl/Khlb')
const Gzjl = () => import ('@/pages/khgl/Gzjl')
const Ddjl = () => import ('@/pages/khgl/Ddjl')
const Bmzd = () => import ('@/pages/xtgl/Bmzd')

const Ghlb = () => import ('@/pages/khgl/Ghlb')
const Jxlb = () => import ('@/pages/khgl/Jxlb')

const Splb = () => import ('@/pages/cpgl/Splb')
const Spjg = () => import ('@/pages/cpgl/Spjg')
const routes = [
    { path: '/login', name: 'login', component: Login },
    { path: '/404', component: notFound, name: '404' },
    { path: '/reload', component: Reload, name: 'reload' },
    {
        path: "/",
        component: Home,
        redirect:{ path: '/count', },
        children: [
            { path: 'count', component: Main, name: '首页' },
        ]
    },
    {
        path: "/",
        name:'客户管理',
        component: Home,
        redirect:{ path: '/khlb', },
        children: [
            // { path: 'count', component: Main, name: '主体' },
            { path: 'khlb', component: Khlb, name: '客户列表' },
            { path: 'gzjl', component: Gzjl, name: '跟踪记录' },
            { path: 'ddjl', component: Ddjl, name: '订单记录' },
            { path: 'ghlb', component: Ghlb, name: '供应商列表' },
            { path: 'jxlb', component: Jxlb, name: '经销商列表' },
        ]
    },
    {
        path: "/",
        name:'商品管理',
        component: Home,
        redirect:{ path: '/splb', },
        children: [
            { path: 'splb', component: Splb, name: '注册产品列表' },
            { path: 'spjg', component: Spjg, name: '商品价格列表' },
        ]
    },
    {
        path: "/",
        name:'系统管理',
        component: Home,
        children: [
            { path: 'bmzd', component: Bmzd, name: '编码字典' },
        ]
    },
]
const router = new Router({
    routes: routes
})

const VueRouterPush = Router.prototype.push

Router.prototype.push = function push (to) {

    return VueRouterPush.call(this, to).catch(err => err)

}

router.beforeEach((to, from, next) => {
    if (to.path != '/login' && !sessionStorage.getItem('loginData')) {
        return next({
            path: '/login'
        })
    }else{
        next()
    }
})
export default router;